import { MediaFadeContentSlide } from '@/modules/animation';


if ([...document.querySelectorAll('.js-animation-media-fade-content-slide')].length) {
    [...document.querySelectorAll('.js-animation-media-fade-content-slide')].forEach(el => new MediaFadeContentSlide(el));
}
